import { customPartyLabel } from '@/blocks/domain/helpers/roleCategories';
import type { RoleParty, RoleResponsibilityRow } from '@/blocks/domain/types/BlockContent/RolesResponsibilitiesContent';
import { resolveTokens, type ResolveTokensOptions } from '@/document-render/application/resolveTokens';
import type { DocumentContext } from '@/document-render/domain/DocumentContext';

function resolvedName(value: string | undefined): string | null {
  const trimmed = value?.trim() ?? '';
  if (!trimmed || trimmed.includes('{{')) return null;
  return trimmed;
}

export function resolveRolePartyLabel(party: RoleParty, context: DocumentContext): string {
  if (party === 'customer') return resolvedName(context.customer?.name) ?? 'Customer';
  if (party === 'company') return resolvedName(context.company?.name) ?? 'Provider';
  return 'Shared';
}

/**
 * What a responsibility prints in its party slot, in the canvas and the PDF alike. A row that kept a
 * free-text party from its legacy form prints that text (variables resolved, as the legacy table did);
 * any other row prints the label of its party.
 */
export function resolveRowPartyLabel(
  row: Pick<RoleResponsibilityRow, 'party' | 'partyLabel'>,
  context: DocumentContext,
  options?: ResolveTokensOptions
): string {
  const custom = customPartyLabel(row);
  const resolved = custom === undefined ? '' : resolveTokens(custom, context, options).trim();
  return resolved || resolveRolePartyLabel(row.party, context);
}
